let WIDTH = 768;
// let HEIGHT = (window.innerHeight / window.innerWidth) * WIDTH;
let HEIGHT = 1665;//~~((window.innerHeight / window.innerWidth) * WIDTH);
//HEIGHT = HEIGHT > 1663 ? 1663 : HEIGHT;
HEIGHT = Math.max(((window.innerHeight / window.innerWidth) * WIDTH), ((window.innerWidth / window.innerHeight) * WIDTH));
HEIGHT = HEIGHT > 1663 ? 1663 : HEIGHT;

// let DEVICE_PIXEL_RATIO = window.devicePixelRatio > 1 ? 2 : 1;
let DEVICE_PIXEL_RATIO = 1;
let RESOLUTION = DEVICE_PIXEL_RATIO > 1 ? '2x' : '1x';
console.log('DEVICE PIXEL RATIO', DEVICE_PIXEL_RATIO);

const config = {
  MEDIA_FONTS_PATH: './media/fonts/',
  MEDIA_MAPS_PATH: './media/maps/',
  MEDIA_IMAGE_PATH: './media/images/',
  MEDIA_AUDIO_PATH: './media/audio/',
  DEBUG_CHILDREN: 0,
  DEBUG_ADVERTISEMENT: 1,
  LOCAL_STORAGE_KEY: 'rumble-bee',
  DEVICE_PIXEL_RATIO: DEVICE_PIXEL_RATIO,
  RESOLUTION: RESOLUTION,
  SCALE: DEVICE_PIXEL_RATIO > 1 ? 0.5 : 1,
  WIDTH: WIDTH,
  HEIGHT: HEIGHT,
  THIRD_WIDTH: WIDTH / 3,
  CENTER_X: WIDTH / 2,
  CENTER_Y: HEIGHT / 2,
  ASPECT_RATIO: WIDTH / HEIGHT,
  TILE_SIZE: 68,
  TILE_X_OFFSET: 10, // (WIDTH - MAP_WIDTH) / 2;
  MAP_X_COUNT: 11,
  MAP_WIDTH: 68 * 11, // (TILE_SIZE * MAP_X_COUNT)
  ROUND: 10000,
  HERO_SIZE: 50,
  UP: 'up',
  DOWN: 'down',
  LEFT: 'left',
  RIGHT: 'right',
  EXIT: 'Exit',
  WALL: 'Walls',
  FLOOR: 'Floor',
  FLOOR_ALPHA: 0.55,
  BEE_MONEY: 'BeeMoney',
  BEE_MONEY_POINTS: 100,
  COINS: 'Coins',
  COINS_POINTS: 50,
  TRAIL: 'Trail',
  TRAIL_POINTS: 10,
  SPIKES: 'Spikes',
  BUMPER: 'Bumpers',
  ZAPPER_WALLS: 'ZapperWalls',
  GATE_BLOCKS: 'GateBlocks',
  POWER_UPS: 'PowerUps',
  EXPANDERS: 'Expanders',
  EXPANDERS_DELAY: 1000,
  EXPANDERS_INTERVAL: 4000,
  EXPANDERS_ROTATE_COUNT: 3,
  EXPANDERS_RADIUS: 70,
  ELECTRIC_GATE: 'ElectricGate',
  ELECTRIC_GATE_SPEED: 100,
  ELECTRIC_GATE_CHARGE: 1250,
  WARPS: 'Warps',
  GATE: 'Gate',
  GATE_SPEED: 80,
  GATE_CLOSED_FRAME: '30-wall-a.png',
  STEP_SPEED: 40,
  TRANSITION_DURATION: 1000,
  ARMOR: 'Armor',
  ARMOR_COST: 50,
  MAGNET: 'Magnet',
  MAGNET_COST: 100,
  MAGNET_RADIUS: 225,
  BOOSTER: 'Booster',
  BOOSTER_COST: 150,
  ANTACID: 'Antacid',
  ANTACID_COST: 200,
  POWER_UP_DURATION: 20000,
  COOL_DOWN: 20000,
  MUSIC_ON: 'musicOn',
  SOUNDS_ON: 'soundsOn',
  BASE_SCENE: 'BASE_SCENE',
  BG_COLORS: ['bg-blue', 'bg-gold', 'bg-green', 'bg-orange', 'bg-pink', 'bg-purple', 'bg-red'],
  BILE: 'Bile',
  BILE_START_SPEED: 0.5,
  BILE_MAX_SPEED: 3,
  BILE_POWER_SPEED: 1,
  BILE_SPEED_INCRAMNET: 0.3,
  BILE_REVERSE_SPEED: -1.5,
  BILE_START_DELAY: 1000,
  MAP: {
    HTP: 'map-0',
    EASY: [
      'map-1',
      'map-2',
      'map-3',
      'map-4',
      'map-5',
      'map-6',
      'map-7',
      'map-8',
      'map-9'
    ],
    MEDIUM: [
      'map-10',
      'map-11',
      'map-12',
      'map-14',
      'map-15',
      'map-18',
      'map-20'
    ],
    HARD: [
      'map-13',
      'map-16',
      'map-21',
      'map-19',
      'map-22',
      'map-23'
    ],
    INTERMISSION: [
      'map-17',
      'map-24',
      'map-25',
      'map-26'
    ]
  },
  MAP_COUNT: {
    EASY: 3,
    MEDIUM: 3,
    HARD: 3,
    INTERMISSION: 1
  },
  SCORE_MEDIUM: 5000,
  SCORE_GREAT: 10000
};

export default config;
